/**
 * @fileoverview This file contains the canonical schema for a character inspiration profile
 * as it is stored in the `character-inspirations` subcollection.
 */
import { z } from 'zod';
import { PersonProfileSchema } from './personality-profile';

/**
 * Defines the schema for an inspiration document stored in the subcollection.
 * It is based on the PersonDataProfile and adds a unique ID.
 * The `id` is now directly from the PersonDataProfile and is not re-generated.
 */
export const CharacterInspirationSchema = PersonProfileSchema;

export type CharacterInspiration = z.infer<typeof CharacterInspirationSchema>;
